import React from "react";
import { Button } from "semantic-ui-react";

import Calibration1_PSM1 from "./Calibration1_PSM1";
import Calibration2_PSM1 from "./Calibration2_PSM1";
import Calibration3_PSM1 from "./Calibration3_PSM1";
import Calibration4_PSM1 from "./Calibration4_PSM1";
import Calibration5_PSM1 from "./Calibration5_PSM1";
import Calibration6_PSM1 from "./Calibration6_PSM1";
import NonLinear_PSM1 from "./NonLinear_PSM1";

const CalibrationIO_PSM1 = () => {
  const [toggleButton, setToggleButton] = React.useState("1");

  const handleClick = (e, { id }) => {
    setToggleButton(id);
  };

  const renderSwitch = (param) => {
    switch (param) {
      case "1":
        return <Calibration1_PSM1 />;
      case "2":
        return <Calibration2_PSM1 />;
      case "3":
        return <Calibration3_PSM1 />;
      // case '4':
      //    return <Calibration4_PSM1/>;
      // case '5':
      //     return <Calibration5_PSM1/>
      // case '6':
      //     return <Calibration6_PSM1/>
      // case '7':
      //     return <NonLinear_PSM1/>
      default:
        return <Calibration1_PSM1 />;
    }
  };

  return (
    <div style={styles.div}>
      <Button.Group toggle style={styles.toggle}>
        <Button
          size="medium"
          id="1"
          active={toggleButton === "1"}
          onClick={handleClick}
          content="Analog IO Calibration Page1"
        />
        <Button
          size="medium"
          id="2"
          active={toggleButton === "2"}
          onClick={handleClick}
          content="Analog IO Calibration Page2"
        />
        <Button
          size="medium"
          id="3"
          active={toggleButton === "3"}
          onClick={handleClick}
          content="Analog IO Calibration Page3"
        />
        {/*<Button*/}
        {/*    size='medium'*/}
        {/*    id='4'*/}
        {/*    active={toggleButton==='4'}*/}
        {/*    onClick={handleClick}*/}
        {/*    content='Analog IO Calibration Page4'*/}
        {/*/> */}
        {/* <Button
                size='medium'
                id='5'
                active={toggleButton==='5'}
                onClick={handleClick}
                content='Analog IO Calibration Page5'
            /> */}
        {/* <Button
                size='medium'
                id='6'
                active={toggleButton==='6'}
                onClick={handleClick}
                content='Analog IO Calibration Page6'
            /> */}
        {/*<Button*/}
        {/*    size='medium'*/}
        {/*    id='7'*/}
        {/*    active={toggleButton==='7'}*/}
        {/*    onClick={handleClick}*/}
        {/*    content='Non Linear Calibration'*/}
        {/*/>*/}
      </Button.Group>
      {renderSwitch(toggleButton)}
    </div>
  );
};

const styles = {
  div: {
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
  },
};

export default CalibrationIO_PSM1;
